import { useCallback, useEffect } from 'react'
import useService from 'Hooks/use-service'
import { getAttempt } from 'Services/exams.service'

export const useGetAttempt = (attemptId?: string) => {
    const { data, isLoading, error, trigger } = useService(getAttempt)

    const fetchAttempt = useCallback(() => {
        if (!attemptId) {
            return
        }
        if (attemptId) {
            trigger(attemptId)
        }
    }, [attemptId, trigger])

    useEffect(() => {
        fetchAttempt()
    }, [fetchAttempt])

    return {
        data,
        isLoading,
        error,
        refetch: fetchAttempt,
    }
}
